import "./App.css";
import { BrowserRouter, useHref, useParams } from "react-router-dom";
import PrivateRoutes from "./Routes/PrivateRoutes";
import TopBar from "./Layouts/TopBar";
import SideMenu from "./Layouts/SideMenu";
import Footer from "./Layouts/Footer";
import PublicRoutes from "./Routes/PublicRoutes";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import api from "./api/axiosInstance";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

function App() {
  const [isLogged, setIsLogged] = useState(false);
  const [closed, setClosed] = useState(true);

  const [userPermissions, setUserPermissions] = useState({
    viewUsers: false,
    viewDashboardVariables: false,
    kpi210: false,
  });
  const [user, setUser] = useState({});

  const getUserPermissions = (roleId) => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Roles/GetRole/" + roleId,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      if (response.data.statusCode === 200) {
        setUserPermissions(response.data.content);
        // console.log(response.data.content);
      }
    });
  };

  useEffect(() => {
    if (localStorage.getItem("uTsReD") != null) {
      getUserPermissions(localStorage.getItem("RTsReD"));
      setIsLogged(true);
    }
  }, [user]);
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          {isLogged && (
            <>
              <div className={"main-body " + (closed ? "closed" : "opened")}>
                <SideMenu
                  userPermissions={userPermissions}
                  closed={closed}
                  setClosed={setClosed}
                />
                <div className="right-body">
                  <TopBar setClosed={setClosed} />
                  <div className="right-body-content">
                    <PrivateRoutes
                      setIsLogged={setIsLogged}
                      userPermissions={userPermissions}
                      setUserPermissions={setUserPermissions}
                    />
                  </div>
                  <Footer />
                </div>
              </div>
            </>
          )}
          {!isLogged && (
            <>
              <PublicRoutes
                setIsLogged={setIsLogged}
                setUser={setUser}
                setUserPermissions={setUserPermissions}
              />
            </>
          )}
        </BrowserRouter>
      </QueryClientProvider>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
